import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <g fill="none" stroke="currentColor" strokeWidth="1.5">
    <path strokeLinecap="round" d="M10.316 3.163H3.579M1.052 3.163h-.42" />
    <path d="M23.369 13.326v3.976a.428.428 0 01-.421.442H21.22c-.194-1.255-1.23-2.21-2.484-2.21-1.255 0-2.29.955-2.484 2.21h-5.98c-.193-1.255-1.229-2.21-2.483-2.21-1.255 0-2.29.955-2.485 2.21H4a.428.428 0 01-.42-.442V6.256c0-.248.184-.442.42-.442h12.21c.236 0 .422.194.422.442V7.58h2.88a.42.42 0 01.387.274l1.996 5.029h1.053c.235 0 .42.194.42.442z" />
    <path strokeLinecap="round" d="M21.895 12.884h-4.421c-.465 0-.843-.396-.843-.884V6.963" />
    <path d="M10.316 18.186c0 1.467-1.129 2.651-2.527 2.651-1.397 0-2.526-1.184-2.526-2.651 0-.15.009-.3.042-.442.194-1.255 1.23-2.21 2.485-2.21 1.254 0 2.29.955 2.484 2.21.033.141.042.292.042.442zM21.263 18.186c0 1.467-1.128 2.651-2.526 2.651s-2.527-1.184-2.527-2.651c0-.15.009-.3.043-.442.193-1.255 1.229-2.21 2.484-2.21s2.29.955 2.484 2.21c.034.141.042.292.042.442z" />
  </g>
);

const Icon = createSvgIcon(svg, 'Truck');

export default Icon;
